import { Box, Typography } from "@mui/material";

const OcrStatus = {
  pending: {
    color: 'warning.main',
    text: 'Lecture automatique en cours...'
  },
  completed: {
    color: 'success.main',
    text: 'Lecture automatique terminée'
  },
  failed: {
    color: 'error.main',
    text: 'Échec de la lecture automatique. Veuillez vérifier manuellement.'
  }
};

const DocumentOcrStatus = ({ document }: { document: any }) => {
  if (!Object.keys(OcrStatus).includes(document.ocr_job_status)) {
    return null;
  };

  const ocrStatus = OcrStatus[document.ocr_job_status as keyof typeof OcrStatus]

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 4, alignItems: 'center', gap: 1 }}>
      <Typography color={ocrStatus.color} sx={{ fontSize: '14px' }}>{ocrStatus.text}</Typography>
      {document.ocr_job_status === 'completed' && (
        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: '500', fontStyle: 'italic' }}>
          L'OCR a pré-rempli le formulaire. Attention, il peut contenir des erreurs. Modifiez-le si besoin pour correspondre au document.
        </Typography>
      )}
    </Box>
  )
};

export default DocumentOcrStatus;